<template>
    <div>
    	<header class="mui-bar mui-bar-nav">
			<a class="mui-icon mui-icon-left-nav mui-pull-left" @click="$router.push({path: '/home'});"></a>
			<h1 class="mui-title">个人中心</h1>
		</header>
		<div class="mui-content">
			<div class="userContent">
				<div class="mui-card myCard usersCard">
					<div class="userImg">
						<img src="../assets/imgs/userImg.png"  class="userLogo"/>
					</div>
					<div id="userName">XXX</div>
					<div>
						<span class="mui-icon-extra mui-icon-extra-phone iphones"></span>
						<span class="tel" id="tels">13800000000</span>
					</div>
				</div>
				
				<div class="mui-card myCard">
					<ul class="mui-table-view">
						<li class="mui-table-view-cell" @click="$router.push({path: '/agreement'});">
							<a class="mui-navigate-right">
								用户协议
							</a>
						</li>
					</ul>
					<ul class="mui-table-view">
						<li class="mui-table-view-cell" @click="unbind">
							<a class="mui-navigate-right">
								解除绑定
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>	
		<!-- <div class="mui-content-padded fixfooter">
			<button type="button" class="mui-btn mui-btn-primary mui-btn-block" @click="unbind">解除绑定</button>
		</div> -->
    </div>
</template>
<script>
	import { UserInfo,Unbound} from '@/request/api';
    export default{
        data: function(){
			return {
				sites: []
			}
		},
		created(){
			this.getUserInfo();
		},
    	methods:{
			getUserInfo(){
				//获取近半年的信息。
				//获取今天时间 以及半年前的日期
				var tenant_id = sessionStorage.getItem("tenant_id");
				UserInfo({     
			    	'tenant_id':tenant_id,
			   	}).then(res => {
			    	// 获取数据成功后的其他操作
			    	if(res.result =='true'){
//			    		console.log(res);
			    		var userInfo = res.data;
			    		$("#userName").html(userInfo.tenant_name);
			    		$("#tels").html(userInfo.tenant_phone);
			    	}
			    	else{
			    		mui.toast(res.description,{ duration:'long'});	
			    	}
		  		}) 
			},
			unbind(){
				//解除绑定
				var tenant_id = sessionStorage.getItem("tenant_id");
				Unbound({     
			    	'tenant_id':tenant_id,
			   	}).then(res => {
			    	// 获取数据成功后的其他操作
			    	if(res.result =='true'){
//			    		console.log(res);
						mui.toast('解除绑定成功！');	
			    	}
			    	else{
			    		mui.toast(res.description,{ duration:'long'});	
			    	}
		  		}) 
			},
		}
    }
</script>
<style>
     @import '../common/css/public.css';
</style>


// WEBPACK FOOTER //
// src/pages/userCenter.vue